import request from 'superagent';
import config from '../config';

module.exports = {
  data() {
    return new Promise((resolve, reject) => {
      request
        .get(`${config.serverUrl}/partner`)
        .set('Content-Type', 'application/json')
        .end(function(err, resp) {
          if (err) {
            return reject(err);
          }

          return resolve(resp.body);
        });
    });
  }
}



// WEBPACK FOOTER //
// ./src/services/partner.js